import { Component, ElementRef, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { TableComponent } from 'src/app/back-office/components/table/table.component';
import config from 'config/default.json';

@Component({
  selector: 'app-vcl-student-manager',
  templateUrl: './vcl-student-manager.component.html',
  styleUrls: ['./vcl-student-manager.component.scss']
})
export class VcStudentManagerComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {}
  platformInfos:{[x: string]: any} = {origin: 'virtualclass', key: 'vcl', root: 'VIRTUALCLASS'}
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  filterData:any = [];
  dataSource:{[x: string]: any}[] = [];
  modes:{ [x:string]: string|number }[] = [];
  pageId = 'student'
  
  ngOnInit(): void { }

  setProgress(data:any){

  }
  sendFilterData(data:any){
    this.filterData = data;
  }
  
}
